/* import __COLOCATED_TEMPLATE__ from './sources-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class SourcesCardComponent extends Component
{
	@service store;
	@service errorManager;
	
	@tracked isAddingNew = false;
	@tracked newSourceName = "";
	@tracked newSourceHost = "";

	@action
	toggleAddingNew() {
		this.isAddingNew = !this.isAddingNew;
	}

	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();

		const newSource = this.store.createRecord('source',
		{
			name: this.newSourceName,
			host: this.newSourceHost,
		});

		try
		{
			await newSource.save();
			await this.store.findRecord('source', newSource.id);
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newSource.rollbackAttributes();
			return;
		}

		this.resetNew();
	}
	
	@action cancelNew()
	{
		this.resetNew();
	}
	
	resetNew()
	{
		this.newSourceName = "";
		this.newSourceHost = "";
		this.isAddingNew = false;
	}
	
	@action
	async deleteSource(source)
	{
		var datasets = await source.datasets;
		if(datasets.length > 0)
		{
			this.errorManager.addError("Source is used by a dataset. Cannot be deleted.", { clearable: true, type: 'validation' });
			return;
		}
		else
		{
			source.deleteRecord();
			try
			{
				await source.save();
			}
			catch (error)
			{
				// Error is displayed by the adapter
				source.rollbackAttributes();
			}
		}
	}
}